import React, { useEffect, useState } from 'react'
import { AuthServices } from '../util/authServices'

const CampanasOfertas = ({ setUserSession, setViewAdminZone, userSession, setCargando, toast }) => {

    const [form, setForm] = useState({
        nombreOferta: '',
        descripcionOferta: '',
        fechaInicio: '',
        fechaFin: '',
        descuentoPorcentaje: ''
    })

    const [campanias, setCampanias] = useState([])

    useEffect(() => {
        getCampaniasVigentes()
    }, [])

    const getCampaniasVigentes = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const response = await authServices.requestPost({}, 22);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setCampanias(objeto || [])
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const closeSession = () => {
        setUserSession({
            nombre: "",
            apellido: "",
            usuario: "",
            role: "USUARIO_LOGIN"
        })
        sessionStorage.removeItem('userSessionStorage')
    }

    const actionNavigate = (action) => {
        setViewAdminZone(action)
    }

    const handleChange = ({ target }) => {
        const { name, value } = target
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        if (!form.nombreOferta || !form.descripcionOferta || !form.fechaInicio || !form.fechaFin || form.descuentoPorcentaje === '') {
            toast('Todos los campos son obligatorios');
            return;
        }

        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                nombreOferta: form.nombreOferta,
                descripcionOferta: form.descripcionOferta,
                fechaInicio: form.fechaInicio,
                fechaFin: form.fechaFin,
                descuentoPorcentaje: parseFloat(form.descuentoPorcentaje)
            }
            const response = await authServices.requestPost(body, 21);
            const { estado, mensaje } = response.data;
            if (estado) {
                setForm({
                    nombreOferta: '',
                    descripcionOferta: '',
                    fechaInicio: '',
                    fechaFin: '',
                    descuentoPorcentaje: ''
                })
                getCampaniasVigentes()
            }
            toast(mensaje)
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        try {
            if (typeof dateStr === 'string') {
                return dateStr.split('T')[0];
            }
            return new Date(dateStr).toLocaleDateString();
        } catch (e) {
            return dateStr;
        }
    }

    const calculateDays = (startStr, endStr) => {
        if (!startStr || !endStr) return '';
        try {
            const start = new Date(startStr.split('T')[0] + 'T00:00:00');
            const end = new Date(endStr.split('T')[0] + 'T00:00:00');
            const diffTime = end.getTime() - start.getTime();
            const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
            return diffDays >= 0 ? `${diffDays} días` : '0 días';
        } catch (e) {
            return '';
        }
    }

    return (
        <>
            <div className='div-container'>
                <div className="row m-0">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                        <div className='div-name-user'>
                            <p>{`${userSession.nombre} ${userSession.apellido}`}</p>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 control-margin" >
                        <div className='div-close-info' style={{ height: "3rem" }}>
                            <button className='btn btn-link btn-close-modal' onClick={() => actionNavigate('HOME')} >Volver a menú</button>
                            <button className='btn btn-link btn-close-modal' onClick={() => closeSession()} >Cerrar</button>
                        </div>
                    </div>
                </div>
                <hr className='hr-report' />
            </div>

            <div className='div-container'>
                <h3 className='btn-close-modal mt-0'>Registrar Campaña / Oferta</h3>
                <form onSubmit={handleSubmit}>
                    <div className="row m-0">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6" >
                            <div className='div-inputs-login'>
                                <p className='p-label-form'> Nombre de la Oferta </p>
                                <input type='text' className='form-control' name='nombreOferta' value={form.nombreOferta} onChange={handleChange} placeholder='Nombre de la oferta' autoComplete='off' />
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6" >
                            <div className='div-inputs-login'>
                                <p className='p-label-form'> Descuento en % </p>
                                <input type='number' min='0' max='100' step='0.01' className='form-control' name='descuentoPorcentaje' value={form.descuentoPorcentaje} onChange={handleChange} placeholder='Ej: 15' />
                            </div>
                        </div>
                    </div>

                    <div className="row m-0">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6" >
                            <div className='div-inputs-login'>
                                <p className='p-label-form'> Fecha de Inicio </p>
                                <input type='date' className='form-control' name='fechaInicio' value={form.fechaInicio} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6" >
                            <div className='div-inputs-login'>
                                <p className='p-label-form'> Fecha de Fin </p>
                                <input type='date' className='form-control' name='fechaFin' value={form.fechaFin} onChange={handleChange} />
                            </div>
                        </div>
                    </div>

                    <div className="row m-0">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                            <div className='div-inputs-login'>
                                <p className='p-label-form'> Descripción de la Oferta </p>
                                <textarea rows='3' className='form-control' name='descripcionOferta' value={form.descripcionOferta} onChange={handleChange} placeholder='Descripción de la oferta...' />
                            </div>
                        </div>
                    </div>

                    <div className="row m-0 mt-3">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                            <div className='div-inputs-login div-inputs-login-flex'>
                                <button type='submit' className='btn btn-primary custom-btn' >
                                    Guardar Campaña
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div className='div-container'>
                <hr className='hr-report mt-4' />
                <h3 className='btn-close-modal mt-3'>Campañas y Ofertas Vigentes</h3>
                <div className='table-responsive mt-3'>
                    <table className='table table-striped table-bordered'>
                        <thead>
                            <tr>                                
                                <th className='color-text-table'>Nombre de la Oferta</th>
                                <th className='color-text-table'>Descripción</th>
                                <th className='color-text-table'>Fecha Inicio</th>
                                <th className='color-text-table'>Fecha Fin</th>
                                <th className='color-text-table'>Días de Vigencia</th>
                                <th className='color-text-table'>Descuento (%)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {campanias.length === 0 ? (
                                <tr>
                                    <td colSpan='6' className='text-center color-text-table'>No hay campañas registradas vigentes</td>
                                </tr>
                            ) : (
                                campanias.map((item) => (
                                    <tr key={item.id}>
                                        <td className='color-text-table'>{item.nombreOferta}</td>
                                        <td className='color-text-table'>{item.descripcionOferta}</td>
                                        <td className='color-text-table'>{formatDate(item.fechaInicio)}</td>
                                        <td className='color-text-table'>{formatDate(item.fechaFin)}</td>
                                        <td className='color-text-table'>{calculateDays(item.fechaInicio, item.fechaFin)}</td>
                                        <td className='color-text-table'>{item.descuentoPorcentaje}%</td>                                       
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default CampanasOfertas